import { apiSlice } from './apiSlice';

const DEPARTMENTS_URL = '/api/departments';

export const departmentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDepartments: builder.query({
      query: () => ({
        url: DEPARTMENTS_URL,
        method: 'GET'
      }),
      providesTags: ['Department']
    }),
    getDepartmentById: builder.query({
      query: (id) => ({
        url: `${DEPARTMENTS_URL}/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'Department', id }]
    }),
    createDepartment: builder.mutation({
      query: (data) => ({
        url: DEPARTMENTS_URL,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Department']
    }),
    updateDepartment: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${DEPARTMENTS_URL}/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Department', id }]
    }),
    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `${DEPARTMENTS_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Department']
    })
  })
});

export const {
  useGetDepartmentsQuery,
  useGetDepartmentByIdQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation
} = departmentsApiSlice; 